import { preloadPath } from './common';

export async function preload(mahouPaths: string[]): Promise<void> {
    await fetch(preloadPath, {
        method: 'POST',
        body: mahouPaths.join('\n'),
    });
}
